import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2 8L2 8.5C2 9.32843 2.67157 10 3.5 10L8.5 10C9.32843 10 10 9.32843 10 8.5L10 8M8 6L6 8M6 8L4 6M6 8L6 2" />
  </svg>
);
